<template>
  <v-container fluid class="pa-0 ma-0">
    <pageHeader class="mb-16"> BUSINESS PULSE® ANALYTICS </pageHeader>
    <UnderLinedHeader class="pb-8 white"
      >Reporting Made For YOU</UnderLinedHeader
    >
    <v-row justify="center" align="center" class="px-12 mb-16">
      <p class="artice-text text-center">
        Timely and accurate management information is one of the primary
        necessities for the operation of a successful business. We offer
        specialized custom report services, and our programming team develops
        applications or mini applications to wrap your software or data in a new
        format.
      </p>
    </v-row>
    <section>
      <v-row class="greyBG" style="margin-top: 6em">
        <v-col
          class="pa-16 mt-8"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'pr-0'"
          justify="end"
          align="end"
          cols="12"
          s="12"
          xs="12"
          lg="6"
          xl="6"
          md="6"
        >
          <BPCarsoule/>
        </v-col>
        <v-col cols="12" s="12" xs="12" lg="6" xl="6" md="6">
          <UnderLinedHeader align="left" class="pt-15 pb-8 "
            :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'"
            >Business Pulse®</UnderLinedHeader
          >
          <p class="text-justify  artice-text" :class="$vuetify.breakpoint.smAndDown?'px-4':'px-16'">
            Our product does things your way. Need a report or a mini
            application? Need real-time results reporting? Business Pulse® is
            just that. Start imagining:
          </p>
          <h4 :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'" >Reporting</h4>
          <hoveredList :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'" :items="reportingList" />
          <h4 class=" pt-8" :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'">
            Mini Applications – If You Can Imagine It, We Can Deliver It!
          </h4>
          <hoveredList :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'" :items="miniAppsList" />
        </v-col>
      </v-row>
    </section>

    <!-- Business Pulse® -->
    <section>
      <v-row class="greyBG " :class="$vuetify.breakpoint.smAndDown?'px-4':'px-16'">
        
        <v-col v-if="!$vuetify.breakpoint.smAndDown"
          class="pa-16 mt-8"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'pr-0'"
          justify="end"
          align="end"
          cols="12"
          s="12"
          xs="12"
          lg="6"
          xl="6"
          md="6"
        >
          <v-img
          max-width="450"
            :src="require('@/assets/imgs/Services/services-reports-red-450x300.jpeg')"
            :lazy-src="require('@/assets/imgs/Services/services-reports-red-450x300.jpeg')"
        
          >
          </v-img>
        </v-col>
        <v-col cols="12" s="12" xs="12" lg="6" xl="6" md="6">
          <UnderLinedHeader align="left" class="pt-15 pb-8"
          :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'"
            >Standard Reports</UnderLinedHeader
          >
          <p class="text-justify  artice-text" :class="$vuetify.breakpoint.smAndDown?'px-0':'px-16'">
            Are the reports you consider “standard” missing from your software
            program? We can create customized reports unique to your firm’s
            needs for any application where we can access data. You may choose
            from a large selection of standard reports for:
          </p>

          <hoveredList :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'" :items="standardReportsList" />
        </v-col>
      </v-row>
    </section>
    <!-- Standard Reports -->
    <section>
      <v-row class="greyBG">
        <v-col
          class="pa-16 mt-8"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'pr-0'"
          justify="end"
          align="end"
          cols="12"
          s="12"
          xs="12"
          lg="6"
          xl="6"
          md="6"
        >
          <ImageModel
            imageName="profit-and-loss.png"
            alt="profit-and-loss.png"
            parentFolder="Services"
          ></ImageModel>
        </v-col>
        <v-col cols="12" s="12" xs="12" lg="6" xl="6" md="6">
          <UnderLinedHeader align="left" class="pt-15 pb-8"
          :class="$vuetify.breakpoint.smAndDown?'pl-4':'pl-16'"
            >Graphs & Dashboards</UnderLinedHeader
          >
          <p class="text-justify  artice-text" :class="$vuetify.breakpoint.smAndDown?'px-4':'px-16'">
            Do you prefer visual representations? We can create customized
            reports unique to your firm’s needs or you may choose from a large
            selection of standard reports. You imagine. . .we create.
          </p>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import ImageModel from "@/components/global/compnentsMixins/ImageModel.vue";
import BPCarsoule from "@/components/BusinessPulseAnalytics/BPCarsoule.vue";
import HoveredList from "@/components/global/compnentsMixins/HoveredList.vue";
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
export default {
  components: { PageHeader, UnderLinedHeader, HoveredList, ImageModel,BPCarsoule },
  data() {
    return {
      reportingList: [
        "Interactive Dashboards you design",
        "Real-time Reporting on any ODBC application",
        "Uses Microsoft’s SQL Server Reporting Services (SSRS)",
        "Sends results to Excel, Word, PDF or Email",
      ],
      miniAppsList: [
        "Add tables to store information your current program can’t",
        "Add features you need that your favorite application doesn’t understand",
        "Uses Microsoft’s SQL Server Reporting Services (SSRS)",
        "Take an off-the-shelf application such as QuickBooks and turn it into a specialized application for you",
      ],
      standardReportsList: [
        "Billing",
        "Receivables",
        "Budget Variance",
        "Receipt Allocation",
        "Productivity",
        "Transactions",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>